module.exports = (count) =>
  if count == 0 then "zero"
  else if count == 1 then "one"
  else "other"



// WEBPACK FOOTER //
// ./app/scripts/data/locales/counting/en.coffee